import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { CfProductDetailPage } from '../productDetailPage';

export class CfProductDetailPageForDrones extends CfProductDetailPage {
    static get config() {
        return {
            contentType: contentTypes.CfProductDetailPage,
            filters: {
                'fields.insuranceType': 'InsuranceForDrones',
            },
        };
    }
}
